module.exports = __webpack_public_path__ + "img/bulgarians-nod-of-head.42196ac0.jpg";